import React, { FC, ReactNode, useState, useRef, useLayoutEffect } from 'react';

// @ts-ignore
import styles from './Hint.scss';

export type BalloonProps = {
  width?: string;
  leftPoint?: number;
  children: ReactNode;
};

export const Balloon: FC<BalloonProps> = ({ width, leftPoint, children }) => {
  const [left, setLeft] = useState<number | string | undefined>(leftPoint);
  const balloonRef = useRef<HTMLDivElement>(null);
  const messageRef = useRef<HTMLDivElement>(null);

  useLayoutEffect(() => {
    // propsで渡された時はそれを使用する
    if (leftPoint) {
      return;
    }

    if (balloonRef.current && messageRef.current) {
      const { offsetLeft: balloonOffsetLeft } = balloonRef.current;
      const { offsetLeft: messageOffsetLeft, clientWidth: messageClientWitdth } = messageRef.current;

      // 画面幅より右にはみ出る場合
      const pointRight = balloonOffsetLeft + messageOffsetLeft + messageClientWitdth;
      if (pointRight > window.innerWidth) {
        setLeft(messageOffsetLeft - (pointRight - window.innerWidth) - 5);
        return;
      }

      // 画面幅より左にはみ出る場合
      const pointLeft = balloonOffsetLeft + messageOffsetLeft;
      if (pointLeft < 0) {
        setLeft(-balloonOffsetLeft + 5);
        return;
      }

      // 基本は中央(+10px)
      if (width) {
        setLeft(-(Number(messageClientWitdth) / 2 - 10));
        return;
      }
    }
  }, []);

  return (
    <div className={styles.balloon} ref={balloonRef}>
      <div className={styles.message} style={{ width: width, left: left }} ref={messageRef}>
        {children}
      </div>
    </div>
  );
};
